<app-loader *ngIf="isDisabled"></app-loader>
<div class="card mt-2 border-radius-0 p-1">
    <div class="card-header">
        <div class="row">
            <div class="col">
                Local Expense
            </div>
            <div class="col-auto"><button type="button" class="btn btn btn-info btn-sm"
                    [routerLink]="['/request/expense/history']" [disabled]="isDisabled"><i class="bi bi-clock-history"
                        *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'History':'Loading...'}}</button></div>

            <div class="col-auto"><button type="button" class="btn btn btn-outline-primary btn-sm" (click)="addItem()"
                    [disabled]="isDisabled"><i class="bi bi-plus" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Add Expense':'Loading...'}}</button></div>
        </div>

    </div>
    <div class="card-body p-0">
        <form name="FilterForm" (ngSubmit)="FilterValidate(FilterForm)" #FilterForm="ngForm">
            <div class="row pb-3">
                <div class="col-md-3">
                    <label for="FromDateObj" class="form-font-label"><span class="text-danger">*</span>From
                        Date</label>
                    <div class="input-group">
                        <input class="form-control" placeholder="dd-mm-yyyy" name="FromDateObj"
                            [(ngModel)]="Filter.FromDateObj" ngbDatepicker #FromDateObj="ngbDatepicker" required
                            [minDate]="mindate" readonly (ngModelChange)="Clear()" />
                        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="FromDateObj.toggle()"
                            type="button"></button>
                    </div>
                    <div class="invalid-feedback">
                        Please select from date!
                    </div>
                </div>
                <div class="col-md-3">
                    <label for="ToDateObj" class="form-font-label"><span class="text-danger">*</span>To
                        Date</label>
                    <div class="input-group">
                        <input class="form-control" placeholder="dd-mm-yyyy" name="ToDateObj"
                            [(ngModel)]="Filter.ToDateObj" ngbDatepicker #ToDateObj="ngbDatepicker" required readonly
                            [minDate]="mindate" (ngModelChange)="Clear()" />
                        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="ToDateObj.toggle()"
                            type="button"></button>
                    </div>
                    <div class="invalid-feedback">
                        Please select to date!
                    </div>
                </div>
                <div class="col-md-3">
                    <label for="Type" class="form-font-label">Type</label>
                    <select class="form-select" aria-label="Type" placeholder="Type" title="Type" name="Type"
                        [(ngModel)]="Filter.Type" #Type="ngModel" (change)="FilterData()" required>
                        <option disabled [value]=null>--Select Type--</option>
                        <option value="All">All</option>
                        <option value="Category">Category</option>
                        <option value="Vehicle">Vehicle</option>
                    </select>
                </div>
                <div class="col"></div>
                <div class="col-auto mt-4  pt-1"><button class="btn btn-primary" [disabled]="isDisabled"><i
                            class="bi bi-cloud-download me-2" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Apply':'Loading...'}}</button></div>
            </div>
        </form>
        <div class="card border-radius-0 mt-1 p-0">
            <div class="card-body p-1">
                <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger" class="customeDatatable table table-bordered">
                    <thead class="table-light">
                        <tr>
                            <th scope="col" style="width: 5px;">#</th>
                            <th style="width: 5px;"><input class="form-check-input header-check" type="checkbox"
                                    id="IsCheck" (change)="CheckAll($event)" name="IsCheck">
                            </th>
                            <th>Action</th>
                            <th>ExpenseDate</th>
                            <th>Category</th>
                            <th>Description</th>
                            <th>Attachment</th>
                            <th>Amount</th>
                            <th>Rate</th>
                            <th>Kilometers</th>
                            <th>From</th>
                            <th>To</th>
                            <!-- <th>Class</th> -->
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let TableData of TableDatas; let i = index">
                            <th scope="row" style="width: 5px;">{{i+1}}</th>
                            <td style="width: 5px;" class="text-center">
                                <div style="width: 5px;"><input class="form-check-input" type="checkbox"
                                        id="IsCheck{{i}}" name="IsCheck{{i}}" [(ngModel)]="TableData['IsCheck']">
                                </div>
                            </td>
                            <td style="text-align: -webkit-center;">
                                <div style="width: 10px;"><i class="bi bi-trash deleteIcon"
                                        (click)="Delete(TableData['ESS_ExpenseRequestDetailsId'])"></i></div>
                            </td>
                            <td style="width: 100px;">
                                <div style="width: 100px;">{{TableData['ExpenseDate']}}</div>
                            </td>
                            <td style="width: 120px;">
                                <div style="width: 120px;">{{TableData['ESS_ExpenseCategoryMasterId'] != null &&
                                    TableData['ESS_ExpenseCategoryMasterId'] >
                                    0 ? TableData['ExpenseCategoryName'] : TableData['VehicleName']}}</div>
                            </td>
                            <td style="width: 200px;">
                                <div style="width: 200px;">{{TableData['Description']}}</div>
                            </td>
                            <td class="attachmentThumbTD">
                                <app-thumbnail-attachment
                                    *ngIf="TableData['Attachment'] != null && TableData['Attachment'] != ''"
                                    [attachmentUrl]="TableData['Attachment']">
                                </app-thumbnail-attachment>
                            </td>
                            <td style="width: 80px;text-align:end">
                                <div style="width: 80px;">{{TableData['ExpenseAmount']}}</div>
                            </td>
                            <td style="width: 50px;text-align:end">
                                <div style="width: 50px;">{{TableData['Rate']}}</div>
                            </td>
                            <td style="width: 70px;text-align:end">
                                <div style="width: 70px;">{{TableData['Kilometers']}}</div>
                            </td>
                            <td style="width: 150px;">
                                <div style="width: 150px;">{{TableData['FromLocation']}}</div>
                            </td>
                            <td style="width: 150px;">
                                <div style="width: 150px;">{{TableData['ToLocation']}}</div>
                            </td>
                            <!-- <td style="width: 120px;">
                                <div style="width: 120px;">{{TableData['ClassName']}}</div>
                            </td> -->
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div class="card-footer">
        <div class="row">
            <div class="col">
            </div>
            <div class="col-auto">
                <button type="button" class="btn btn-primary" [disabled]="isDisabled">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>Requested Amount :
                    {{calRequestAmountTotal()}}</button>
            </div>
            <div class="col-auto">
                <button type="button" class="btn btn-primary mx-1" [disabled]="isDisabled" (click)="CheckSubmit()"><i
                        class="bi bi-check2" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Submit':'Loading...'}}</button>
            </div>
        </div>
    </div>
</div>